import { assign, each, isEqual } from 'lodash'

export default {
  created () {
    this.resetFilters()

    this.prefillFilters()
  },

  watch: {
    $route () {
      this.resetFilters()

      this.prefillFilters()
    }
  },

  computed: {
    /**
     * Get the filters query params.
     *
     * @return object
     */
    queryParams () {
      let params = {}

      each(this.filters, (value, param) => {
        if (value) {
          params[param] = value
        }
      })

      if (this.$route.params.clientId !== undefined) {
        params.clientId = this.$route.params.clientId
      }

      if (this.$route.params.managerId !== undefined) {
        params.managerId = this.$route.params.managerId
      }

      if (this.status !== undefined) {
        params.status = this.status
      }

      params.timezone = new Date().getTimezoneOffset()

      return params
    },

    /**
     * Determine if we have filters applied.
     *
     * @return bool
     */
    haveAppliedFilters () {
      return !isEqual(this.filters, this.initialFiltersState)
    }
  },

  methods: {
    /**
     * Update the filters in the query string.
     *
     * @return void
     */
    updateFiltersInQueryString (replace = false) {
      let query = assign({}, this.$route.query)

      for (let filter in this.filters) {
        if (this.filters[filter]) {
          query[filter] = this.filters[filter]
        } else {
          delete query[filter]
        }
      }

      if (replace) {
        this.$router.replace({ query })
      } else {
        this.$router.push({ query }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error
          }
        })
      }
    },

    /**
     * Handle applying the filters by pushing them to the query string.
     *
     * @return Promise
     */
    handleApplyFiltersCallback () {
      this.updateFiltersInQueryString()

      return Promise.resolve()
    },

    /**
     * Prefill filters upon page refresh.
     *
     * @return void
     */
    prefillFilters () {
      for (let filter in this.filters) {
        if (
          this.$route.query[filter] !== null &&
          this.$route.query[filter] !== undefined
        ) {
          this.setFilter({ filter, value: this.$route.query[filter] })
        }
      }
    },

    /**
     * Handle resetting the filters.
     *
     * @return void
     */
    handleResetFiltersCallback () {
      this.resetFilters()

      this.updateFiltersInQueryString()
    }
  }
}
